// ============================================
// Auth/MyPage/Settings Events (ES6)
// Re-export from individual module events for backwards compatibility
// ============================================

import { initAuthEvents } from './auth/events.js';
import { initMyPageEvents } from './mypage/events.js';
import { initSettingsEvents } from './settings/events.js';

// Re-export individual init functions
export { initAuthEvents } from './auth/events.js';
export { initMyPageEvents } from './mypage/events.js';
export { initSettingsEvents } from './settings/events.js';

// ============================================
// Combined Initialization
// ============================================

export function initAllAuthEvents() {
  initAuthEvents();
  initMyPageEvents();
  initSettingsEvents();
}

// 모듈 초기화
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllAuthEvents);
} else {
  initAllAuthEvents();
}

console.log('[Auth Events] auth-events.js 모듈 로드 완료');
